import { API_ENDPOINTS } from '../constants/apiEndpoints';
import { LoginCredentials } from '../types/auth';
import { axiosInstance, turnstileTokenManager } from '../utils/fetcher';

export const authService = {
  login: async (credentials: LoginCredentials) => {
    const { data } = await axiosInstance.post(API_ENDPOINTS.LOGIN, credentials);
    localStorage.setItem('token', data.token);

    return data;
  },

  sendOtpResetPassword: async (data: { email?: string, phoneNumber?: string}, turnstileToken?: string) => {
    // Store Turnstile token in session storage for the API request
    if (turnstileToken) {
      turnstileTokenManager.set(turnstileToken);
    }
    
    try {
      await axiosInstance.post(API_ENDPOINTS.SEND_OTP_RESET_PASSWORD, data);
    } finally {
      // Clear token after request completes
      turnstileTokenManager.clear();
    }
  },

  verifyOtpResetPassword: async (payload: {otp: string, email?: string, phoneNumber?: string}) => {
    return await axiosInstance.post(API_ENDPOINTS.VERIFY_OTP_RESET_PASSWORD, payload);
  },

  resetPassword: async (data: { phoneNumber?: string, email?: string, password: string, token: string}) => {
    return await axiosInstance.post(API_ENDPOINTS.RESET_PASSWORD, data);
  }
};